module.exports = __webpack_public_path__ + "img/19.problem_sink.893ad4e9.svg";